import { Component, OnInit } from '@angular/core';
import { Ng2DeviceService } from 'ng2-device-detector';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { Restaurant } from '../restaurant';
import { RestaurantEvent } from '../restaurant-event';

import { RestaurantService } from '../restaurant.service';

import { MessageService }     from '../message.service';



import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'promotion',
	templateUrl: './promotion.component.html',
	styleUrls: ['./promotion.component.css'] 

})

export class PromotionComponent implements OnInit {
    deviceInfo = null;
        device = "unknown";
	constructor(
 		private sanitizer: DomSanitizer,
		private m_restaurant_service: RestaurantService,
        private deviceService: Ng2DeviceService,
  
  	) {}

	m_events: RestaurantEvent[];
	name;path;bkurl;url;

	ngOnInit(): void {

		this.getRestaurantEvents();
		this.name = this.m_restaurant_service.name;
		this.bkurl = this.m_restaurant_service.url+"modules/Event/EventForm.php?restaurant="+this.m_restaurant_service.name;
		this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.bkurl); 
		
	}

	getRestaurantEvents(): void {
		console.log("EventsComponent getRestaurantEvents")
		this.m_restaurant_service.getRestaurantEvents(this.m_restaurant_service.name).then(
			restaurantEvents => {
				console.log("EventsComponent callback")
				console.log("EventsComponent callback restaurantEvents: " + restaurantEvents)
				this.m_events = restaurantEvents;
                                this.deviceInfo = this.deviceService.getDeviceInfo();
                                this.device = this.deviceInfo.device;
                      
                                
			}
		);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/promotion/promotion.component.ts